module.exports = __webpack_public_path__ + "img/3100569.jpg";